import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import getServiceItemIds from 'owa-mail-store/lib/services/utils/getServiceItemIds';
import moveItemRequest from 'owa-service/lib/factory/moveItemRequest';
import moveItemOperation from 'owa-service/lib/operation/moveItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * The service command to move items to a specified destination folder
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
export default function moveItemsService(itemIds, destinationFolderId, sourceFolderId) {
    var requestBody = configureRequestBody(itemIds, destinationFolderId);
    return moveItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body;
    });
}
/**
 * Configure the MoveItemRequest body
 * @param itemIds the ids of the items to be moved
 * @param destinationFolderId the id of destination folder to move to
 * @return a Promise which contains the MoveItemResponse
 */
function configureRequestBody(itemIds, destinationFolderId) {
    return moveItemRequest({
        ToFolderId: getServiceContextFolderId(destinationFolderId),
        ItemIds: getServiceItemIds(itemIds),
        ReturnNewItemIds: true,
    });
}
//# sourceMappingURL=moveItemsService.js.map